import { render } from "./LeftMenuItem.vue?vue&type=template&id=22ff7b88"
import script from "./LeftMenuItem.vue?vue&type=script&setup=true&lang=js"
export * from "./LeftMenuItem.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Partials/LeftMenuItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22ff7b88"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22ff7b88', __exports__)) {
    console.log('reload')
    api.reload('22ff7b88', __exports__)
  }
  
  module.hot.accept("./LeftMenuItem.vue?vue&type=template&id=22ff7b88", () => {
    console.log('re-render')
    api.rerender('22ff7b88', render)
  })

}


export default __exports__